/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable */
import AgreementApi from '@/api/agreement';
import type { RegisterUserAgreement, UserContractType } from '@/api/agreement/types';
import type { LegalConstract } from '@/api/legal-constact/type';
import { openThirdPage } from '@/api/native/utils';
import LegalAgreementsMixins from '@/mixins/legal-agreements';
import { AgreementPo } from '@/po/agreement';
import { RouterV2Enum } from '@/router/router-names';
import { Cell, CellGroup } from 'vant';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DefaultPage from './components/default-page';
import { codeEnums } from '@/shared/utils/platform';
import { isUseGeneralAgreesApi } from '@/constant';
import { agreementService } from '@/service/confirm-agreements';
import { local } from '@/shared/utils/storage';
import { ubtSendError } from '@/shared/utils/ubt';
import { LocalEnum } from '@/enums/local';

const style = require('./index.module.scss');

@Component({ name: 'LegalContracts' })
export default class LegalContracts extends Mixins(LegalAgreementsMixins) {
  private legalConstract: LegalConstract | UserContractType = Object.create(null);

  /**
   * userContract 判断是否为臻有钱用户服务协议
   * 从confirmFinanceAgreements协议弹窗跳转过来
  */
  @Prop({
    type: Boolean,
    default: false,
  })
  private readonly userContract?: boolean

  /**
   * skAppContract 判断是否为独立 app 登录协议
  */
  @Prop({
    type: Boolean,
    default: false,
  })
  private readonly skAppContract?: boolean

  /** 是否营销落地页 */
  @Prop({
    type: Boolean,
    default: false,
  })
  private readonly marketContract?: boolean

  /** 协议场景类型(落地页-短信外投) */
  @Prop(String) private readonly sceneType?: string

  /** h5场景查看协议是否新开webview */
  @Prop(Boolean) private readonly h5NewWebview?: boolean

  /**
   * 是否使用会话session缓存
   * ocr后置提现流程，从活体协议弹窗跳转过来，会通过sessionStorage会传递需要展示的协议数据
   */
  @Prop(Boolean) private readonly useSessionCached?: boolean

  /** 用户注册同意的协议(基建平台) */
  private platformRegisterContract: RegisterUserAgreement[] = [];

  /** 指定排序最后的协议列表(TODO: 待后续接入统一的服务接口，删除) */
  private agreementSpecifyLastList: AgreementPo[] = [];

  /** 请求接口后，未返回任何协议数据 */
  private get noContractData() {
    const { agreements, agreementChannels = [] } = this.legalConstract  as LegalConstract;
    return !agreements.length && !agreementChannels.length && !this.platformRegisterContract.length
  };

  /** 是否展示缺省页 默认不展示 */
  private isShowDefaultPage: boolean = false;

  /**离开页面时根据条件显示授权弹窗 */
  private async beforeRouteLeave(
    to: Route,
    from: Route,
    next: (...d: unknown[]) => void,
  ) {
    // 1.执行页面回退跳转
    next();
    // 2.如果是从【臻有钱用户服务协议弹窗跳转过来】，在回退时执行下，授信弹窗展示判定
    if (this.userContract) {
      await agreementService.confirmFinanceAgreements();
    }
  }

  /** 检测是否展示服务授权协议弹窗 */
  private async checkContracDialog() {
          const confirmResult = await agreementService.confirmFinanceAgreements();
    if(confirmResult) {
      this.getAgreements();
    }
  }

  /**
   * 协议缺省页点击去同意唤起协议confirmFinanceAgreements弹窗，点击协议弹窗中的协议还是跳转当前路由页面
   * 由于路由没变，只是参数变了contractType=1 等价于userContract=true，所以页面不会刷新
   * 需要通过监听userContract判断是否是缺省页直接跳转过来（注意，不需要加immediate:true，第一次进入页面create中会获取数据）
   */
  @Watch('userContract')
  private async refreshPageData(val:boolean) {
    await this.getAgreements();
    /** 此时为从缺省页跳转到协议展示页再次回退场景 */
    if (!val && this.isShowDefaultPage) {
      /** 重新检测是否需要弹窗 */
      this.checkContracDialog();
    }
  }

  /** 缺省页点击去同意 */
  private async goAgree() {
    this.checkContracDialog();
  }

  private async created() {
    this.getAgreements();
  }

  private async getAgreements() {
    this.$ubtModuleExpose(
      'finance_financeAgreementst_list'
    )
    /** 初始化缺省页状态 */
    this.isShowDefaultPage = false;

    const querySceneType = this.sceneType ? Number(this.sceneType) : undefined;
    /** 通用协议接口已包含：信贷业务协议、平台基建协议，无需额外请求平台协议接口 */
    const isUseGeneralApi = isUseGeneralAgreesApi();

    if (this.useSessionCached) {
      const contractList = local.get(LocalEnum.readContractList);

      if (contractList) {
        this.legalConstract = { agreements: contractList as AgreementPo[] } as LegalConstract;
      } else {
        ubtSendError({
          name: 'contract-list-not-found',
          message: window.location.href,
        });
      }
    } else if (this.skAppContract) {
      // 数科 app 登录协议链接
      this.legalConstract = await AgreementApi.getSkAppLoginContracts();
    } else if (this.marketContract) {
        // 营销落地页展示协议
        // 只展示未同意过的协议
        const agreementList = (await AgreementApi.getAgreedInfo(querySceneType, codeEnums.app));
        const filterAgreementList = agreementList.agreements.filter(item => !item.isAgreed);

        this.legalConstract = { ...agreementList, ...{ agreements: filterAgreementList } };
        this.platformRegisterContract = await (isUseGeneralApi ? [] : AgreementApi.getNoLoginRegisterAgrees());
    } else {
      if (this.userContract) {
        // 从协议弹窗跳转进来只展示未同意过的协议
        const agreementList = await AgreementApi.getAgreedInfo();
        const filterAgreementList = agreementList.agreements.filter(item => {
          return !item.isAgreed
        })
        this.legalConstract = { ...agreementList, ...{ agreements: filterAgreementList } };
        this.platformRegisterContract = await (isUseGeneralApi ? [] : AgreementApi.getWaitRegisterAgrees());
      } else {
        /** 此处是直接点击设置页面入口进入
         * 新用户未同意任何协议点击进入会展示空白页，故需优化展示缺省页
         */
        this.legalConstract = await this.getLegalAgreements();
        this.platformRegisterContract = await (isUseGeneralApi ? [] : AgreementApi.getRegisteredAgreements());
        /** 当数据返回且页面不展示任何协议 */
        if (this.noContractData) {
          this.isShowDefaultPage = true;
        }
      }
    }
    /** 指定协议排序最后处理 */
    if (this.legalConstract && Array.isArray(this.legalConstract.agreements)) {
      /** agreementType === 4 指定协议类型为 “个人征信信息查询及使用授权书” */
      const targetIdx = this.legalConstract.agreements.findIndex(it => it.agreementType === 4);

      if (targetIdx > -1) {
        this.agreementSpecifyLastList.push(...this.legalConstract.agreements.splice(targetIdx, 1));
      }
    }
  }

  private onCheckLegal(url: string) {
    if (this.h5NewWebview) {
      window.open(url);
    } else {
      openThirdPage(url);
    }
  }

  private onChannelContract() {
    this.$router.push(RouterV2Enum.cooperationChannel);
  }

  private renderAgreements(list: (AgreementPo | RegisterUserAgreement)[]) {
    if (list && list.length) {
      return list.map((item) => (
        <Cell
          title={item.agreementName}
          isLink
          onClick={() => this.onCheckLegal(item.agreementUrl || '')}
          key={`${item.agreementUrl || ''}__${item.agreementName}`}
        >
          <span slot="right-icon" class={style.rightIcon} />
        </Cell>
      ));
    }

    return null;
  }

  private render() {
    return (
      !this.isShowDefaultPage ? (
      <div class={style.LegalContracts}>
        <CellGroup>
          {this.renderAgreements(this.legalConstract && this.legalConstract.agreements)}
          {this.renderAgreements(this.platformRegisterContract)}
          <Cell
            v-show={
              !this.userContract
              && this.legalConstract
              && (this.legalConstract as LegalConstract).agreementChannels
              && (this.legalConstract as LegalConstract).agreementChannels.length
            }
            title="合作渠道服务协议"
            isLink
            onClick={this.onChannelContract.bind(this)}
          >
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
          {this.renderAgreements(this.agreementSpecifyLastList)}
        </CellGroup>
        { this.isShowDefaultPage ? (
          <DefaultPage onGoAgree={this.goAgree.bind(this)} />
        ) : null }
      </div>
      ) : (
        <DefaultPage onGoAgree={this.goAgree.bind(this)} />
      ))
  }
}
